const EXTRANET_GROUPS = [
  "extranet_CoDi",
  "extranet_GeOp",
  "extranet_Supervisor",
  "extranet_Cliente",
];

export { EXTRANET_GROUPS };
